import Modal from '../Modal';

import * as Styled from './InstructionalVideo.styled';

export default function InstructionalVideo({ open, onClose }) {
  if (!open) {
    return null;
  }

  return (
    <Modal
      isOpen={open}
      onCloseModal={onClose}
      title="Cách Tìm Cổ Phiếu"
      contentClassName="max-w-[96%] md:max-w-md m-auto w-full"
      mainContentClassName="modal-center max-w-[98vw] sm:max-w-[708px] m-auto w-full"
      childrenClassName="mt-0"
    >
      <Styled.ContentWrapper className="relative">
        <iframe
          id="yt_player_iframe"
          src="https://www.youtube.com/embed/Dur3ekEcoUQ?si=7xK-icpvi6dim3by&rel=0"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </Styled.ContentWrapper>
    </Modal>
  );
}
